import api from '@/apis/di/accountingObjectCategoryAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';

// Combo grid Loại khách hàng nhà cung cấp
export const useAccountingObjectCategoryComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();

  // func call api lấy dữ liệu combo
  const onAccountingObjectCategoryComboboxLoadData = (payload, row, column) => {
    payload.sort = 'accounting_object_category_code';
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let extend = [{ Field: 'inactive', Value: false, Ors: ors }];
    payload.filter = extendFilter(payload.filter, extend);
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // config columns combo
  const accountingObjectCategoryComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã loại KH,NCC',
        dataField: 'accounting_object_category_code',
        width: 150,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên loại KH,NCC',
        dataField: 'accounting_object_category_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
         width: 450,
      },
    ],
    displayField: 'accounting_object_category_name',
    valueField: 'accounting_object_category_id',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onAccountingObjectCategoryComboboxLoadData,
  };

  return {
    accountingObjectCategoryComboConfig,
    onAccountingObjectCategoryComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
